/**
 * DOM helpers for the site plan mini card plugin.
 *
 * Owns all DOM queries and mutations related to site plan community wrappers
 * and their active state. The plugin calls these functions at the appropriate
 * lifecycle points but remains free of direct DOM operations.
 *
 * Effect boundary: every export touches the DOM. No business logic lives here.
 *
 * @module searchResultsMap/components/sitePlanMiniCardDom
 */

import { SITE_PLAN_CLASS_NAMES } from '../services/sitePlanBehavior';

/**
 * Queries all site plan community wrapper elements that match the given communityId.
 *
 * @param {number|string} communityId
 * @returns {NodeListOf<HTMLElement>}
 */
export function getCommunityWrappers(communityId) {
  if (!communityId) {
    return [];
  }

  return document.querySelectorAll(`[data-site-plan-community-id="${communityId}"]`);
}

/**
 * Adds or removes the active CSS class on all site plan community wrapper elements
 * that match the given communityId.
 *
 * @param {number|string} communityId
 * @param {boolean} isActive
 */
export function setCommunityActiveState(communityId, isActive) {
  getCommunityWrappers(communityId).forEach((element) => {
    if (isActive) {
      element.classList.add(SITE_PLAN_CLASS_NAMES.active);
      return;
    }
    element.classList.remove(SITE_PLAN_CLASS_NAMES.active);
  });
}
